import React, { useContext, Fragment, useEffect } from "react";
import { TipoContatoContext } from "../TipoContatoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarTipoContato = () => {
  const { values, setValues, resetScreen } = useContext(TipoContatoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={TipoContatoContext}>
        <div className="col-12 col-md-4">
          <label>Descrição</label>
          <input
            className="form-control"
            type="text"
            name="tipoContatoDescricao"
            value={values.searchData.tipoContatoDescricao}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={TipoContatoContext} />
    </Fragment>
  );
};

export default PesquisarTipoContato;
